// 【公共組件】使用場景
export default {
    'useSence.tips1': '請選擇使用場景',
    'useSence.tips2': '請選擇使用場景(必選)' ,
}
 